module.exports = __webpack_public_path__ + "static/media/glyphicons-halflings-regular.fa277232.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap-sass/assets/fonts/bootstrap/glyphicons-halflings-regular.woff
 ** module id = 159
 ** module chunks = 0
 **/